import { IState } from './state';
import { IStore } from '../index';
import { GetterTree } from 'vuex';

export default {
    getSharedDoubleRooms: (state) => {
        const sharedRooms = (state.doubleRoomAmount * 2) - (state.travelerNumber - state.singleRoomAmount);
        return sharedRooms > 0 ? sharedRooms : 0;
    },
    getCommonDoubleRooms: (state, getters) => state.doubleRoomAmount - getters.getSharedDoubleRooms,
    doubleRoomFactor: (state) => (state.hasSharedDoubleRoom) ? 1 : 2,
    doubleRoomsPerTraveler: (state, getters) => Math.floor(state.travelerNumber / getters.doubleRoomFactor),
    getTravelerNumber: state => {
        return state.travelerNumber;
    }
} as GetterTree<IState, IStore>
